import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ReportDialogService {

  componentsMap = {};

  constructor(private modalService: NgbModal) { }

  public addComponent(name: string, component: any) {
    this.componentsMap[name] = component;
  }

  public display(config: any, data: any) {

    const component = this.componentsMap[config.component];

    if (!component) {
      //  TODO: Alert component not found
      alert(`ERROR: Component ${config.component} not found.`);
    }

    const modalRef = this.modalService.open(component, {
      centered: false,
    });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.config = config;
    modalRef.componentInstance.changeRef.markForCheck();
    return modalRef.result;
  }
}
